
import { z } from "zod";

export const TicketStatusValues = ["TRIAGE", "OPEN", "RESOLVED", "CANCELED"] as const;
export const TicketStatusSchema = /* @__PURE__ */ z.enum(TicketStatusValues);
export const TicketStatus: (typeof TicketStatusSchema)["enum"] = { "TRIAGE": "TRIAGE", "OPEN": "OPEN", "RESOLVED": "RESOLVED", "CANCELED": "CANCELED" };
export type TicketStatus = (typeof TicketStatusValues)[number];
export const TicketStatusDisplayNames = { "TRIAGE": "Triage",
"OPEN": "Open",
"RESOLVED": "Resolved",
"CANCELED": "Canceled", } satisfies Record<TicketStatus, string>;
